import { handleLocalApi } from '@/lib/local-crm';
import { handleSupabaseApi } from '@/lib/supabase-crm';
import { dataMode } from '@/config/runtime';

type ApiConfig = {
  params?: Record<string, any>;
  responseType?: string;
  headers?: Record<string, string>;
};

const handler = dataMode === 'supabase' ? handleSupabaseApi : handleLocalApi;

const api = {
  get(url: string, config?: ApiConfig) {
    return handler('GET', url, undefined, config);
  },
  post(url: string, data?: any, config?: ApiConfig) {
    return handler('POST', url, data, config);
  },
  put(url: string, data?: any, config?: ApiConfig) {
    return handler('PUT', url, data, config);
  },
  patch(url: string, data?: any, config?: ApiConfig) {
    return handler('PATCH', url, data, config);
  },
  delete(url: string, config?: ApiConfig) {
    return handler('DELETE', url, undefined, config);
  },
};

export default api;
